(() => {
  if (window.perfectLookCommerceReady) return;
  window.perfectLookCommerceReady = true;
  const cartSelector = '[data-pl-commerce-cart]';
  let changing = false;

  function initCart(root = document) {
    root.querySelectorAll(cartSelector).forEach(cart => {
      cart.setAttribute('data-enhanced', '');
      cart.querySelectorAll('[data-pl-cart-line]').forEach(line => {
        const input = line.querySelector('[data-pl-cart-quantity]');
        const minus = line.querySelector('[data-pl-cart-step="-1"]');
        const plus = line.querySelector('[data-pl-cart-step="1"]');
        if (!input) return;
        if (minus) minus.disabled = Number(input.value) <= Number(input.min || 1);
        if (plus) plus.disabled = Boolean(input.max) && Number(input.value) >= Number(input.max);
      });
    });
  }

  function status(cart, message, error = false) {
    const notice = cart.querySelector('[data-pl-cart-status]');
    if (notice) {
      notice.hidden = false;
      notice.setAttribute('role', error ? 'alert' : 'status');
      notice.textContent = message;
    }
  }

  async function changeLine(cart, line, quantity, trigger) {
    if (changing) return;
    changing = true;
    const key = line.dataset.lineKey;
    const lineIndex = [...cart.querySelectorAll('[data-pl-cart-line]')].indexOf(line);
    const action = trigger?.dataset.plCartStep;
    cart.setAttribute('aria-busy', 'true');
    cart.querySelectorAll('button,input').forEach(control => { control.disabled = true; });
    status(cart, 'Updating your bag…');
    try {
      const root = window.Shopify?.routes?.root || '/';
      const response = await fetch(`${root}cart/change.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity, sections: cart.dataset.sectionId, sections_url: window.location.pathname })
      });
      const payload = await response.json();
      if (!response.ok) throw new Error(payload.description || payload.message || 'Your bag could not be updated. Please try again.');
      const html = payload.sections?.[cart.dataset.sectionId];
      const next = html && new DOMParser().parseFromString(html, 'text/html').querySelector(cartSelector);
      if (!next) { window.location.reload(); return; }
      cart.replaceWith(next);
      initCart();
      const updatedLine = [...next.querySelectorAll('[data-pl-cart-line]')].find(item => item.dataset.lineKey === key);
      const adjacentLine = next.querySelectorAll('[data-pl-cart-line]')[Math.max(0, lineIndex - 1)];
      let focusTarget = updatedLine?.querySelector(action ? `[data-pl-cart-step="${action}"]:not(:disabled)` : '[data-pl-cart-quantity]');
      focusTarget ||= updatedLine?.querySelector('[data-pl-cart-quantity]') || adjacentLine?.querySelector('[data-pl-cart-remove]') || next.querySelector('.pl-commerce__empty .pl-commerce__button');
      focusTarget?.focus({ preventScroll: true });
      document.querySelectorAll('[data-pl-cart-count]').forEach(count => {
        count.textContent = String(payload.item_count);
        count.toggleAttribute('data-empty', payload.item_count === 0);
      });
      document.querySelectorAll('[data-pl-cart-link]').forEach(link => {
        const template = link.dataset.plCartLabelTemplate;
        if (template) link.setAttribute('aria-label', template.replace('__COUNT__', String(payload.item_count)));
      });
      const message = quantity === 0 ? 'Item removed from your bag.' : 'Your bag has been updated.';
      status(next, message);
      const liveRegion = document.querySelector('[data-pl-live-region]');
      if (liveRegion) liveRegion.textContent = message;
      document.dispatchEvent(new CustomEvent('perfectlook:cart-updated', { detail: { item_count: payload.item_count } }));
    } catch (error) {
      status(cart, error.message || 'Your bag could not be updated. Please try again.', true);
      const input = line.querySelector('[data-pl-cart-quantity]');
      if (input) input.value = input.defaultValue;
      cart.querySelectorAll('button,input').forEach(control => { control.disabled = false; });
      cart.removeAttribute('aria-busy');
      initCart();
      trigger?.focus({ preventScroll: true });
    } finally {
      changing = false;
    }
  }

  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-pl-cart-step],[data-pl-cart-remove]');
    if (!trigger) return;
    const cart = trigger.closest(cartSelector);
    const line = trigger.closest('[data-pl-cart-line]');
    if (!cart || !line) return;
    event.preventDefault();
    if (changing) return;
    const input = line.querySelector('[data-pl-cart-quantity]');
    if (!input) return;
    if (trigger.hasAttribute('data-pl-cart-remove')) { changeLine(cart, line, 0, trigger); return; }
    const step = Number(input.step || 1);
    const min = Number(input.min || 1);
    const max = input.max ? Number(input.max) : Infinity;
    const next = Math.max(min, Math.min(max, Number(input.value) + Number(trigger.dataset.plCartStep) * step));
    if (next === Number(input.value)) return;
    input.value = String(next);
    if (input.reportValidity()) changeLine(cart, line, next, trigger);
  });

  document.addEventListener('change', event => {
    const input = event.target.closest('[data-pl-cart-quantity]');
    if (!input || changing) return;
    if (!input.reportValidity()) return;
    const cart = input.closest(cartSelector);
    const line = input.closest('[data-pl-cart-line]');
    const quantity = Number(input.value);
    if (cart && line && Number.isInteger(quantity)) changeLine(cart, line, quantity, input);
  });

  // Keep manually shared search URLs product-only, as all native search forms are.
  if (document.querySelector('[data-pl-commerce-search]')) {
    const url = new URL(window.location.href);
    if (url.searchParams.has('q') && url.searchParams.get('type') !== 'product') {
      url.searchParams.set('type', 'product');
      url.searchParams.delete('page');
      window.location.replace(url.href);
    }
  }
  initCart();
  document.addEventListener('shopify:section:load', () => initCart());
})();
